import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectBaggageAndPersonalItemsSCTIStep = (state) => state.get('baggageAndPersonalItemsSCTIStep');

const makeSelectBaggageAndPersonalItemsSCTIStep = () => createSelector(
  selectBaggageAndPersonalItemsSCTIStep,
  (baggageAndPersonalItemsSCTIStepState) => ({
    whatHappenedToYourBaggageAndPersonalItems: mapWithDefault(
      baggageAndPersonalItemsSCTIStepState,
      () => baggageAndPersonalItemsSCTIStepState.getIn(['form', 'whatHappenedToYourBaggageAndPersonalItems']),
      ''
    ),
    hasYourBaggageBeenReturnedToYou: mapWithDefault(
      baggageAndPersonalItemsSCTIStepState,
      () => baggageAndPersonalItemsSCTIStepState.getIn(['form', 'hasYourBaggageBeenReturnedToYou']),
      ''
    ),

    dateWhenYourLuggageWasReturned: mapWithDefault(
      baggageAndPersonalItemsSCTIStepState,
      () => baggageAndPersonalItemsSCTIStepState.getIn(['form', 'dateWhenYourLuggageWasReturned']),
      ''
    ),

    infoBaggageDelayItems: mapWithDefault(baggageAndPersonalItemsSCTIStepState, () => baggageAndPersonalItemsSCTIStepState.getIn(['form', 'infoBaggageDelayItems']) && baggageAndPersonalItemsSCTIStepState.getIn(['form', 'infoBaggageDelayItems']).toJS(), ''),

    whatItemsAreYouClaimingFor: mapWithDefault(
      baggageAndPersonalItemsSCTIStepState,
      () => baggageAndPersonalItemsSCTIStepState.getIn(['form', 'whatItemsAreYouClaimingFor']),
      ''
    ),

    infoEssentialMedicationItems: mapWithDefault(baggageAndPersonalItemsSCTIStepState, () => baggageAndPersonalItemsSCTIStepState.getIn(['form', 'infoEssentialMedicationItems']) && baggageAndPersonalItemsSCTIStepState.getIn(['form', 'infoEssentialMedicationItems']).toJS(), ''),
    infoJewelleryOrTraditionalWatchesItems: mapWithDefault(baggageAndPersonalItemsSCTIStepState, () => baggageAndPersonalItemsSCTIStepState.getIn(['form', 'infoJewelleryOrTraditionalWatchesItems']) && baggageAndPersonalItemsSCTIStepState.getIn(['form', 'infoJewelleryOrTraditionalWatchesItems']).toJS(), ''),
    infoLaptopsTabletsOrCamerasItems: mapWithDefault(baggageAndPersonalItemsSCTIStepState, () => baggageAndPersonalItemsSCTIStepState.getIn(['form', 'infoLaptopsTabletsOrCamerasItems']) && baggageAndPersonalItemsSCTIStepState.getIn(['form', 'infoLaptopsTabletsOrCamerasItems']).toJS(), ''),
    infoOtherUnspecifiedItems: mapWithDefault(baggageAndPersonalItemsSCTIStepState, () => baggageAndPersonalItemsSCTIStepState.getIn(['form', 'infoOtherUnspecifiedItems']) && baggageAndPersonalItemsSCTIStepState.getIn(['form', 'infoOtherUnspecifiedItems']).toJS(), ''),
    infoSpecifiedHighValueItems: mapWithDefault(baggageAndPersonalItemsSCTIStepState, () => baggageAndPersonalItemsSCTIStepState.getIn(['form', 'infoSpecifiedHighValueItems']) && baggageAndPersonalItemsSCTIStepState.getIn(['form', 'infoSpecifiedHighValueItems']).toJS(), ''),
    infoBankCardsOrTravelDocumentsItems: mapWithDefault(baggageAndPersonalItemsSCTIStepState, () => baggageAndPersonalItemsSCTIStepState.getIn(['form', 'infoBankCardsOrTravelDocumentsItems']) && baggageAndPersonalItemsSCTIStepState.getIn(['form', 'infoBankCardsOrTravelDocumentsItems']).toJS(), ''),
    infoCashItems: mapWithDefault(baggageAndPersonalItemsSCTIStepState, () => baggageAndPersonalItemsSCTIStepState.getIn(['form', 'infoCashItems']) && baggageAndPersonalItemsSCTIStepState.getIn(['form', 'infoCashItems']).toJS(), ''),
  })
);

const makeSelectBaggageAndPersonalItemsSCTIStepErrors = () =>
  createSelector(selectBaggageAndPersonalItemsSCTIStep, (state) => state.get('errors'));

export {
  makeSelectBaggageAndPersonalItemsSCTIStep,
  makeSelectBaggageAndPersonalItemsSCTIStepErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.BaggageAndPersonalItems/selectors.js